module.exports = __webpack_public_path__ + "static/media/mv-logo-background.97a700d4.jpg";